import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  currentYear: any;
  buildNumber = environment.buildInfo;
  isProd = environment.production || false;
  constructor() {}

  ngOnInit(): void {
    this.buildNumber = environment.buildInfo;
    this.currentYear = new Date().getFullYear();
  }
}
